import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetDocumentos = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/documentos/tipo/${params.tipo}?clave=${params.clave}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getDocumentosMutation: mutation.mutate,
    };
}